module.exports = __webpack_public_path__ + "img/html.3ea1c031.png";